import { render, staticRenderFns } from "./order-submission.vue?vue&type=template&id=c2f9e6e6&scoped=true"
import script from "./order-submission.vue?vue&type=script&lang=js"
export * from "./order-submission.vue?vue&type=script&lang=js"
import style0 from "./order-submission.vue?vue&type=style&index=0&id=c2f9e6e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f9e6e6",
  null
  
)

export default component.exports